import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useCompanyData(withTrashed = false) {
    const { data: companies, isPlaceholderData: isPlaceholderDataCompanies } = useQuery({
        queryKey: ['companies-options'],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.companies.options.get', { withTrashed }));
            return data;
        },
        placeholderData: [],
    });

    return {
        companies,
        isPlaceholderDataCompanies,
    };
}
